<template>
  <v-card class="text-center mx-auto" max-width="850px">
    <v-container>
      <v-form ref="form" v-model="formValidity">
        <v-toolbar v-if="readOnly" dense :key="$store.getters.getRefreshTime">
          <v-icon v-if="dbKey === ''">mdi-cloud-off-outline</v-icon>
          <v-spacer></v-spacer>
          <template v-if="timeStamp">
            <v-expansion-panels focusable>
              <v-expansion-panel>
                <v-expansion-panel-header>{{timeLapsedWords(timeStamp)}}</v-expansion-panel-header>
                <v-expansion-panel-content>{{timeOfReading}} - {{dateOfReading}}</v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </template>
          <template v-else>{{ cardTitle }}</template>
          <v-spacer></v-spacer>
          <v-btn v-if="false && editEnabled(timeStamp)" icon @click="editSymptoms">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-toolbar>
        <v-toolbar v-else dense>
          <v-btn class="my-2" @click="$emit('user-symptoms-cancel')">Annulla</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!(recovered || formValidity)"
            color="accent"
            class="my-2"
            @click="OnSave"
          >Salva</v-btn>
        </v-toolbar>
        <v-row>
          <v-col class="d-flex" cols="12" md="3">
            <v-select
              v-model="symptoms.condition"
              :items="stateChoice"
              :label="readOnly ? '' : 'Condizione'"
              hint="Condizione"
              persistent-hint
              :disabled="readOnly"
              dense
              required
              :rules="requiredRules"
              @change="OnChangeState"
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" md="3">
            <v-select
              v-model="symptoms.breath"
              :items="breathStates"
              :label="readOnly ? '' : 'Affanno'"
              hint="Respirazione"
              persistent-hint
              :disabled="readOnly || recovered"
              dense
              required
              :rules="requiredRules"
            ></v-select>
          </v-col>
          <v-col class="d-flex" cols="12" md="6">
            <v-select
              v-model="symptoms.stateList"
              :items="symptomsChoice"
              :label="readOnly ? '' : 'Sintomi'"
              hint="Sintomi"
              persistent-hint
              :disabled="readOnly || recovered"
              dense
              multiple
              required
              :rules="atLeastOneRules"
              @change="OnChangeSymptomState"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="!readOnly" cols="4">
            <v-select
              v-model="symptoms.temperaturePoint"
              :items="temperaturePointChoice"
              :label="readOnly ? '' : 'Dove?'"
              hint="Come misuri la febbre"
              persistent-hint
              dense
              :required="!recovered"
              :rules="requiredRules"
            ></v-select>
          </v-col>
          <v-col cols="8">
            <TemperatureReading
              title
              :sub-title="readOnly ? temperaturePointLable : ''"
              :temperatureValue="temperatureValue"
            />
            <v-slider
              v-if="!readOnly"
              v-model="symptoms.temperature"
              @click.stop
              :color="color"
              track-color="grey"
              always-dirty
              prepend-icon="mdi-minus"
              @click:prepend.stop="
                symptoms.temperature = symptoms.temperature - 1
              "
              append-icon="mdi-plus"
              @click:append.stop="
                symptoms.temperature = symptoms.temperature + 1
              "
              min="350"
              max="425"
            ></v-slider>
          </v-col>
        </v-row>
        <v-row v-if="!readOnly || symptoms.bpm || symptoms.SpO2">
          <v-col v-if="!readOnly || symptoms.bpm" cols="12" md="6">
            <v-text-field
              type="number"
              v-model="symptoms.bpm"
              label="Pulsazioni"
              hint="Frequenza Cardiaca"
              placeholder="facoltativo"
              persistent-hint
              :rules="cardioRules"
            ></v-text-field>
          </v-col>

          <v-col v-if="!readOnly || symptoms.SpO2" cols="12" md="6">
            <v-text-field
              type="number"
              v-model="symptoms.SpO2"
              label="Saturazione di Ossigeno"
              hint="SpO2%"
              placeholder="facoltativo"
              persistent-hint
              :rules="SpO2Rules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-toolbar v-if="!readOnly && $vuetify.breakpoint.smAndDown" dense>
          <v-btn class="my-2" @click="$emit('user-symptoms-cancel')">Annulla</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!(recovered || formValidity)"
            color="accent"
            class="my-2"
            @click="$emit('user-symptoms-added')"
          >Salva</v-btn>
        </v-toolbar>
      </v-form>
    </v-container>
  </v-card>
</template>
<script>
import { formatDistanceToNow } from "date-fns";
import itLocale from "date-fns/locale/it";
import TemperatureReading from "@/components/TemperatureReading";

export default {
  name: "UserSymptoms",
  components: {
    TemperatureReading
  },
  props: {
    cardTitle: {
      type: String,
      default: ""
    },
    timeStamp: {
      type: Number,
      default: 0
    },
    symptoms: {
      type: Object,
      default: () => ({
        condition: false,
        temperature: 350,
        temperaturePoint: false,
        stateList: false,
        breath: false,
        cough: false
      })
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    dbKey: {
      type: String,
      default: ""
    }
  },
  watch: {
    temperatureValue() {
      if (!this.symptoms.temperaturePoint && !this.formValidity)
        this.$refs.form.validate();
    }
  },
  methods: {
    timeLapsedWords(ts) {
      if (ts > 1) {
        const opt = { addSuffix: true, locale: itLocale };
        return formatDistanceToNow(ts, opt);
      }
      return "";
    },
    editEnabled(ts) {
      const timeLimit = 1000 * 60 * 5,
        time = new Date().getTime(ts);
      return ts + timeLimit > time;
    },
    editSymptoms() {
      if (this.dbKey) this.$emit("edit-user-symptoms", { key: this.dbKey });
    },
    OnChangeState(e) {
      if (e === "recovered") {
        this.recovered = true;
        if (!this.symptoms.temperaturePoint) {
          // Reset Validation
          this.symptoms.stateList = false;
          this.symptoms.breath = false;
        }
      } else {
        this.recovered = false;
      }
    },
    OnChangeSymptomState(e) {
      if (e.length === 0) {
        this.symptomsChoice.forEach(p => (p.disabled = false));
      } else {
        const modalChoices = this.symptomsChoice,
          modal = modalChoices.filter(v => v.modal || false)[0].value;
        if (e.includes(modal)) {
          this.symptomsChoice
            .filter(p => p.value !== modal)
            .forEach(p => (p.disabled = true));
        } else {
          this.symptomsChoice.filter(p => p.value === modal)[0].disabled = true;
        }
      }
    },
    OnSave() {
      this.$emit("user-symptoms-added", this.symptoms);
    }
  },
  data: () => ({
    formValidity: false,
    requiredRules: [v => !!v || "Dato richiesto."],
    atLeastOneRules: [v => (!!v && v.length > 0) || "Dato richiesto."],
    cardioRules: [
      v =>
        v === undefined || !v.trim()
          ? true
          : (!isNaN(parseInt(v)) && v >= 10 && v <= 250) ||
            "Valori validi (10->250)."
    ],

    SpO2Rules: [
      v =>
        v === undefined || !v.trim()
          ? true
          : (!isNaN(parseInt(v)) && v >= 10 && v <= 100) ||
            "Valori validi (10->100)."
    ],
    dialog: false,
    recovered: false,
    breathStates: [
      { value: "assente", text: "Respiro regolare" },
      { value: "leggero", text: "Leggero Affano" },
      { value: "riposo", text: "Affano a Riposo" },
      { value: "grave", text: "Grave Affano" },
      { value: "ossigeno", text: "Terapia Ossigeno" },
      { value: "ipossia", text: "Labbra Viola" }
    ],
    symptomsChoice: [
      { value: "none", text: "Nessuno", modal: true },
      { value: "shivers", text: "Brividi" },
      { value: "cough", text: "Tosse" },
      { value: "nasuea", text: "Nausea" },
      { value: "smell", text: "Non sento odori" },
      { value: "taste", text: "Non sento sapori" }
    ],
    stateChoice: [
      { value: "recovered", text: "Guarito" },
      { value: "active", text: "Lieve malessere" },
      { value: "bedridden", text: "A letto" },
      { value: "hospitalized", text: "Ricoverato" },
      { value: "notPresent", text: "Non presente" }
    ],
    temperaturePointChoice: [
      { value: "arm", text: "Ascellare" },
      { value: "oral", text: "Orale" },
      { value: "infrared", text: "Termometri a infrarossi" },
      { value: "rectal", text: "Rettale" }
    ]
  }),
  computed: {
    timeOfReading() {
      // https://stackoverflow.com/questions/2388115/get-locale-short-date-format-using-javascript
      const time = new Date(this.timeStamp);
      return time.toLocaleTimeString("it-IT");
    },
    dateOfReading() {
      // https://stackoverflow.com/questions/2388115/get-locale-short-date-format-using-javascript
      const time = new Date(this.timeStamp);
      return time.toLocaleDateString("it-IT");
    },
    temperatureValue() {
      return this.symptoms.temperature === undefined
        ? 0
        : this.symptoms.temperature;
    },
    temperaturePointLable() {
      const lable = this.temperaturePointChoice.filter(
        x => x.value === this.symptoms.temperaturePoint
      );
      return lable.length ? lable[0].text : "";
    },
    color() {
      if (this.temperatureValue < 360) return "indigo";
      if (this.temperatureValue < 365) return "green";
      if (this.temperatureValue < 375) return "amber";
      if (this.temperatureValue < 380) return "orange";
      return "red";
    }
  }
};
</script>
